import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import VueFeather from 'vue-feather'
import i18n from './translation'
Vue.use(VueFeather)
Vue.config.productionTip = false
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
import './assets/tailwind.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import DropdownMenu from 'v-dropdown-menu'
import 'v-dropdown-menu/dist/v-dropdown-menu.css' // Base style, required.
Vue.use(DropdownMenu)
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)
VTooltip.options.autoHide = false
import Constants from "@/plugins/Constants";
Vue.use(Constants);
import DateFormatUnifier from "@/plugins/DateFormatUnifier";
Vue.use(DateFormatUnifier);
import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
  titlePosition: 'left',
  masks: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: 'YYYY-MM-DD HH:mm:ss',
    inputDateTime: 'YYYY-MM-DD HH:mm:ss',
    inputDateTime24hr: "YYYY-MM-DD HH:mm:ss",
    dayPopover: 'WWW, MMM D, YYYY',
    data: 'YYYY-MM-DD HH:mm:ss',
  },
  datePicker: {
    popover: {
      visibility: 'focus',
    }
  }
});
import x5GMaps from 'x5-gmaps';
Vue.use(x5GMaps, {
  key: 'AIzaSyBJXQ2w_kvAGneMf93FLBUsQXOocg_8V_0',
  libraries: ['visualization']
});
Vue.filter('date_utc_to_local', function (value) {
  if (!value) return ''
  return Intl.DateTimeFormat('pl-PL', {
    dateStyle: 'short',
    timeStyle: 'medium'
  }).format(new Date(value.replace(" ", "T") + 'Z'))
})

// import LogRocket from 'logrocket';
// if (document.getElementById('reports_url').value.includes('reports-test.service.symec.net')) { //dev env
//   LogRocket.init('symec/reports_test');
// } else if (document.getElementById('reports_url').value.includes('reports.service.symec.net')) { //live env
//   LogRocket.init('symec/reports_live');
// }

class Reports extends HTMLElement {
  connectedCallback() {
    this.innerHTML = "<div id='app'></div>"
    store.dispatch("autologin").then(() => {
      new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
      }).$mount('#app')
    }).catch(err => {
      console.log('ups - autologin failed', err)
    })
  }
}
customElements.define("app-reports", Reports);